export function classNames(...names: (string | boolean | undefined)[])
{
    return names.filter(name => name).join(' ');
}
